import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import style from './SetUpdateCardPin.module.scss';
import OTP from '../../../../common/Formik/OTP/OTP';
import Button from "../../../../common/Button/Button";
import { SERVICESTYPE, STATUS_CODE } from "../../../../../utils/constants";
import { validationMessage } from "../../../../../Helper/helperfunction";
import { generateOTPAction, setUpdateAction, } from "../../../../../features/user/userSlice";
import emailStyles from "../../../../pages/OnboardScreens/EmailVerification/EmailVerification.module.scss";

const SetUpdateCardPin = ({ cardId, setUpdate, handleClose }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const validationSchema = Yup.object({
        otp: Yup.string().required(validationMessage("OTP")),
        pin: Yup.string().required(validationMessage("PIN")),
    });
    const [timer, setTimer] = useState(60);
    const [seconds, setSeconds] = useState();
    const [showBtn, setShowBtn] = useState(false);
    const userData = useSelector((state) => state?.persist?.userInfo);

    const formik = useFormik({
        initialValues: {
            otp: "",
            pin: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const payload = {
                otp: values.otp,
                pin: values.pin,
            };

            try {
                const response = await dispatch(setUpdateAction(payload, cardId));
                if (response?.data?.status === STATUS_CODE.successful) {
                    setLoading(false);
                    handleClose();
                    setUpdate((prev) => !prev);
                }
            } catch (error) {
                setLoading(false);
                console.log("PIN ERROR", error);
            }
        },
    });

    const generateOTP = async () => {
        const data = {
            username: await userData?.email,
            type: SERVICESTYPE?.EMAIL,
            service: "CARD_PIN_UPDATE",
        };
        try {
            const response = await dispatch(generateOTPAction(data));
            if (response?.status === 200) {
                reSetTime();
            }
        } catch (error) {
            console.log("Something went wrong:", error);
        }
    };

    const setTime = () => {
        if (!seconds || seconds > 0) {
            const timer = setInterval(() => {
                setSeconds((second) => {
                    if (second <= 0) {
                        return clearInterval(timer);
                    }
                    return second - 1;
                });
            }, 1000);
        }
    };

    const reSetTime = () => {
        setSeconds(180); // 3 minutes in seconds
        setTime();
    };

    const handleResend = () => {
        generateOTP();
        setTimer(60);  // reset timer to 60 as per original default
        setShowBtn(false);
        formik.resetForm();
    };

    useEffect(() => {
        let interval;

        if (timer > 0) {
            setShowBtn(false);
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else {
            setShowBtn(true);
        }

        return () => clearInterval(interval);
    }, [timer]);


    return (
        <section className={style.viewCardPin}>

            <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <h4>Set/Update Pin</h4>
                <h6>Enter the 6-digit code sent to your Email.</h6>

                <p>Enter OTP </p>
                <OTP
                    name="otp"
                    value={formik.values.otp}
                    formik={formik}
                    onChange={(value) => formik.setFieldValue("otp", value)}
                    placeholder="------"
                />
                <div className={emailStyles.btn_restotp}>
                    {showBtn ? (
                        <Button
                            className={` ${emailStyles.restBtn}`}
                            onClick={handleResend}
                            type="button"
                            variant="without_bg_border"
                        >
                            Re send
                        </Button>
                    ) : (
                        <p>Re send verification code in {timer}s</p>
                    )}
                </div>

                <p>Enter Pin </p>
                <OTP
                    name="pin"
                    value={formik.values.pin}
                    formik={formik}
                    onChange={(value) => formik.setFieldValue("pin", value)}
                    placeholder="------"
                />

                <Button
                    fluid
                    className={style.btn_pin}
                    type="button"
                    disabled={loading}
                    onClick={(e) => {
                        formik.handleSubmit(e);
                    }}
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Updating...
                        </>
                    ) : (
                        "Set/Update PIN"
                    )}
                </Button>

            </form>
        </section>
    );
};

export default SetUpdateCardPin;
